module.exports = __webpack_public_path__ + "static/img_link_card_01@2x-62c8630ef3b1fe9b01c4939db2aa711f.png";